import { render, staticRenderFns } from "./hafalan.vue?vue&type=template&id=eaaa3670"
import script from "./hafalan.vue?vue&type=script&lang=js"
export * from "./hafalan.vue?vue&type=script&lang=js"
import style0 from "./hafalan.vue?vue&type=style&index=0&id=eaaa3670&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports